/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { CreateLinearAcceleratorDtoSourceAxisDistance } from './CreateLinearAcceleratorDtoSourceAxisDistance';
import {
    CreateLinearAcceleratorDtoSourceAxisDistanceFromJSON,
    CreateLinearAcceleratorDtoSourceAxisDistanceFromJSONTyped,
    CreateLinearAcceleratorDtoSourceAxisDistanceToJSON,
} from './CreateLinearAcceleratorDtoSourceAxisDistance';
import type { ElectronBeamQualitiesDto } from './ElectronBeamQualitiesDto';
import {
    ElectronBeamQualitiesDtoFromJSON,
    ElectronBeamQualitiesDtoFromJSONTyped,
    ElectronBeamQualitiesDtoToJSON,
} from './ElectronBeamQualitiesDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { MedicalSystemBeamLimitingDeviceType } from './MedicalSystemBeamLimitingDeviceType';
import {
    MedicalSystemBeamLimitingDeviceTypeFromJSON,
    MedicalSystemBeamLimitingDeviceTypeFromJSONTyped,
    MedicalSystemBeamLimitingDeviceTypeToJSON,
} from './MedicalSystemBeamLimitingDeviceType';
import type { MedicalSystemBeamProduction } from './MedicalSystemBeamProduction';
import {
    MedicalSystemBeamProductionFromJSON,
    MedicalSystemBeamProductionFromJSONTyped,
    MedicalSystemBeamProductionToJSON,
} from './MedicalSystemBeamProduction';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { NullableOneOfPropertyOfStorageLocation } from './NullableOneOfPropertyOfStorageLocation';
import {
    NullableOneOfPropertyOfStorageLocationFromJSON,
    NullableOneOfPropertyOfStorageLocationFromJSONTyped,
    NullableOneOfPropertyOfStorageLocationToJSON,
} from './NullableOneOfPropertyOfStorageLocation';
import type { OneOfPropertyOfPtw100InternalArea } from './OneOfPropertyOfPtw100InternalArea';
import {
    OneOfPropertyOfPtw100InternalAreaFromJSON,
    OneOfPropertyOfPtw100InternalAreaFromJSONTyped,
    OneOfPropertyOfPtw100InternalAreaToJSON,
} from './OneOfPropertyOfPtw100InternalArea';
import type { PhotonBeamQualitiesDto } from './PhotonBeamQualitiesDto';
import {
    PhotonBeamQualitiesDtoFromJSON,
    PhotonBeamQualitiesDtoFromJSONTyped,
    PhotonBeamQualitiesDtoToJSON,
} from './PhotonBeamQualitiesDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * 
 * @export
 * @interface LinearAcceleratorDto
 */
export interface LinearAcceleratorDto {
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinearAcceleratorDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof LinearAcceleratorDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof LinearAcceleratorDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof LinearAcceleratorDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof LinearAcceleratorDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof LinearAcceleratorDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof LinearAcceleratorDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof LinearAcceleratorDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinearAcceleratorDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof LinearAcceleratorDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof LinearAcceleratorDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinearAcceleratorDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof LinearAcceleratorDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof LinearAcceleratorDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinearAcceleratorDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    typeId?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof LinearAcceleratorDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {StateOfUse}
     * @memberof LinearAcceleratorDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {MedicalSystemBeamLimitingDeviceType}
     * @memberof LinearAcceleratorDto
     */
    beamLimitingDeviceType?: MedicalSystemBeamLimitingDeviceType;
    /**
     * 
     * @type {MedicalSystemBeamProduction}
     * @memberof LinearAcceleratorDto
     */
    beamProduction?: MedicalSystemBeamProduction;
    /**
     * 
     * @type {ElectronBeamQualitiesDto}
     * @memberof LinearAcceleratorDto
     */
    beamQualitiesElectron?: ElectronBeamQualitiesDto;
    /**
     * 
     * @type {PhotonBeamQualitiesDto}
     * @memberof LinearAcceleratorDto
     */
    beamQualitiesPhoton?: PhotonBeamQualitiesDto;
    /**
     * 
     * @type {CreateLinearAcceleratorDtoSourceAxisDistance}
     * @memberof LinearAcceleratorDto
     */
    sourceAxisDistance?: CreateLinearAcceleratorDtoSourceAxisDistance | null;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof LinearAcceleratorDto
     */
    parentCoordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {NullableOneOfPropertyOfStorageLocation}
     * @memberof LinearAcceleratorDto
     */
    imageLocation?: NullableOneOfPropertyOfStorageLocation;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    externalRtSystemId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    externalFileSystemPath?: string | null;
    /**
     * 
     * @type {OneOfPropertyOfPtw100InternalArea}
     * @memberof LinearAcceleratorDto
     */
    ptw100AreaName?: OneOfPropertyOfPtw100InternalArea;
    /**
     * 
     * @type {string}
     * @memberof LinearAcceleratorDto
     */
    $type?: LinearAcceleratorDtoTypeEnum;
}


/**
 * @export
 */
export const LinearAcceleratorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsLinearAcceleratorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.LinearAcceleratorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type LinearAcceleratorDtoTypeEnum = typeof LinearAcceleratorDtoTypeEnum[keyof typeof LinearAcceleratorDtoTypeEnum];


/**
 * Check if a given object implements the LinearAcceleratorDto interface.
 */
export function instanceOfLinearAcceleratorDto(value?: unknown): value is LinearAcceleratorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(LinearAcceleratorDtoTypeEnum)[0];
}

export function LinearAcceleratorDtoFromJSON(json: any): LinearAcceleratorDto {
    return LinearAcceleratorDtoFromJSONTyped(json, false);
}

export function LinearAcceleratorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinearAcceleratorDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'typeId': !exists(json, 'typeId') ? undefined : json['typeId'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'beamLimitingDeviceType': !exists(json, 'beamLimitingDeviceType') ? undefined : MedicalSystemBeamLimitingDeviceTypeFromJSON(json['beamLimitingDeviceType']),
        'beamProduction': !exists(json, 'beamProduction') ? undefined : MedicalSystemBeamProductionFromJSON(json['beamProduction']),
        'beamQualitiesElectron': !exists(json, 'beamQualitiesElectron') ? undefined : ElectronBeamQualitiesDtoFromJSON(json['beamQualitiesElectron']),
        'beamQualitiesPhoton': !exists(json, 'beamQualitiesPhoton') ? undefined : PhotonBeamQualitiesDtoFromJSON(json['beamQualitiesPhoton']),
        'sourceAxisDistance': !exists(json, 'sourceAxisDistance') ? undefined : CreateLinearAcceleratorDtoSourceAxisDistanceFromJSON(json['sourceAxisDistance']),
        'parentCoordinateSystem': !exists(json, 'parentCoordinateSystem') ? undefined : CoordinateSystemFromJSON(json['parentCoordinateSystem']),
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'imageLocation': !exists(json, 'imageLocation') ? undefined : NullableOneOfPropertyOfStorageLocationFromJSON(json['imageLocation']),
        'externalRtSystemId': !exists(json, 'externalRtSystemId') ? undefined : json['externalRtSystemId'],
        'externalFileSystemPath': !exists(json, 'externalFileSystemPath') ? undefined : json['externalFileSystemPath'],
        'ptw100AreaName': !exists(json, 'ptw100AreaName') ? undefined : OneOfPropertyOfPtw100InternalAreaFromJSON(json['ptw100AreaName']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function LinearAcceleratorDtoToJSON(value?: LinearAcceleratorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'typeSpecification': value.typeSpecification,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isArchived': value.isArchived,
        'typeId': value.typeId,
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'state': StateOfUseToJSON(value.state),
        'beamLimitingDeviceType': MedicalSystemBeamLimitingDeviceTypeToJSON(value.beamLimitingDeviceType),
        'beamProduction': MedicalSystemBeamProductionToJSON(value.beamProduction),
        'beamQualitiesElectron': ElectronBeamQualitiesDtoToJSON(value.beamQualitiesElectron),
        'beamQualitiesPhoton': PhotonBeamQualitiesDtoToJSON(value.beamQualitiesPhoton),
        'sourceAxisDistance': CreateLinearAcceleratorDtoSourceAxisDistanceToJSON(value.sourceAxisDistance),
        'parentCoordinateSystem': CoordinateSystemToJSON(value.parentCoordinateSystem),
        'serialNumber': value.serialNumber,
        'imageLocation': NullableOneOfPropertyOfStorageLocationToJSON(value.imageLocation),
        'externalRtSystemId': value.externalRtSystemId,
        'externalFileSystemPath': value.externalFileSystemPath,
        'ptw100AreaName': OneOfPropertyOfPtw100InternalAreaToJSON(value.ptw100AreaName),
        '$type': value.$type,
    });
}

